<template>
  <div class="page_heading pane">
    <button
        v-if="closeOnBack"
        class="orcaBtn btn"
        style="width: 100%; height: 100%;"
        @click="handleBackAndClose"
    >
      Back
    </button>
    <router-link v-else :to="back">
      <button class="orcaBtn btn" style="width: 100%; height: 100%;">Back</button>
    </router-link>
    <div>
      <h1 class="red_color">
        <slot name="title"/>
      </h1>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    back: { required: true, type: Object },
    closeOnBack: { type: Boolean, default: false }
  },
  methods: {
    async handleBackAndClose() {
      // Navigate first (just like router-link)
      if (this.back) {
        await this.$router.push(this.back);
      }
      // Attempt to close the tab/window
      window.close();
      // Optionally emit for fallback
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
div {
  border: none;
  background-color: inherit;
  border-radius: 10px;
}

.page_heading {
  padding-left: 1em;
  margin-bottom: 2em;
  display: grid;
  grid-template-columns: 100px auto;
}

.pane {
  padding: 1em;
  background-color: white;
  border: 1px solid #eee;
  border-radius: 10px;
  margin-bottom: 1em;
}

button.orcaBtn {
  width: auto;
  max-width: fit-content;
}
</style>
